import { processApiFieldErrors } from '../../utils/processApiFieldErrors'
import { getErrorMessage } from '../../utils/utils'
import {
  TEAM_FINDER_BE_TO_FORM_FIELD,
  TEAM_FINDER_BE_TO_FIELD_TITLE,
} from './teamFinderErrorMaps'

export interface ApplyTeamFinderApiErrorDeps {
  /** Set the inline per-field error map (keyed by filter form field). */
  setFieldErrors: (errors: Record<string, string>) => void
  /** Summary toast for non-field errors (web: message.error). */
  notifyError: (message: string) => void
}

/**
 * Translate a thrown Team Finder search error into inline field errors (family
 * pattern). Field errors show inline only; otherwise fall back to the backend
 * message (then a generic message).
 */
export const applyTeamFinderApiError = (
  err: unknown,
  deps: ApplyTeamFinderApiErrorDeps
): void => {
  const { setFieldErrors, notifyError } = deps
  const e = err as {
    invalid_fields?: Record<string, string | string[]>
    message?: string
  }

  const { formErrors, titles, hasFieldErrors } = processApiFieldErrors(
    e.invalid_fields,
    {
      fieldMap: TEAM_FINDER_BE_TO_FORM_FIELD,
      titleMap: TEAM_FINDER_BE_TO_FIELD_TITLE,
    }
  )

  if (!hasFieldErrors || titles.length === 0) {
    // No field errors, or every key was unmapped — clear inline errors and
    // surface the backend message (or a generic fallback).
    setFieldErrors({})
    notifyError(e.message ?? getErrorMessage(err))
    return
  }

  // Field errors: show them inline only, no summary toast.
  setFieldErrors(formErrors)
}
